import { motion } from "framer-motion";
import ServiceCard from "@/components/ServiceCard";
import { Car, Plane, Hotel, Compass, Map } from "lucide-react";
import PageBanner from "@/components/PageBanner";
import PaymentPartners from "@/components/PaymentPartners";
import { useLanguage } from "@/lib/LanguageContext";

export default function Services() {
  const { t } = useLanguage();

  const services = [
    {
      title: t("carHire"),
      description: "4x4 vehicles perfect for safari adventures",
      icon: Car,
      href: "/services/car-hire",
      features: [
        "Latest model 4x4 vehicles",
        "Professional drivers available",
        "Comprehensive insurance coverage",
        "Custom itinerary planning"
      ]
    },
    {
      title: t("airTicketing"),
      description: "Domestic and international flight bookings",
      icon: Plane,
      href: "/services/air-ticketing",
      features: [
        "Best deals on flights",
        "Multiple airline options",
        "Group booking discounts",
        "24/7 travel support"
      ]
    },
    {
      title: t("accommodation"),
      description: "Luxury lodges to tented camps",
      icon: Hotel,
      href: "/services/accommodation",
      features: [
        "Luxury safari lodges",
        "Tented wilderness camps",
        "Boutique hotels",
        "All-inclusive packages"
      ]
    },
    {
      title: t("wildlifeSafaris"),
      description: "Guided wildlife viewing experiences",
      icon: Compass,
      href: "/ExploreUganda",
      features: [
        "Expert wildlife guides",
        "Custom safari packages",
        "Photography tours",
        "Conservation focused"
      ]
    },
    {
      title: t("culturalTours"),
      description: "Cultural and adventure tours",
      icon: Map,
      href: "/Destinations",
      features: [
        "Cultural village visits",
        "Adventure activities",
        "City tours",
        "Special interest tours"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <PageBanner
        title={t("services")}
        description="Comprehensive safari services ensuring your Uganda adventure is comfortable and memorable"
        backgroundImage="/giraffe.JPG"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <p className="text-xl md:text-2xl leading-relaxed max-w-4xl mx-auto text-gray-700 mb-12">
            <span className="font-semibold text-green-700">Comprehensive travel services</span> for your East African adventure. From comfortable transport and quality accommodations to expert guides and seamless logistics, we handle every detail to ensure you enjoy an unforgettable journey.
          </p>
        </motion.div>

        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-2 font-heading">Our Services</h2>
          <div className="w-24 h-1 bg-green-600 mx-auto rounded-full mb-4"></div>

          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Explore our range of services designed to make your safari adventure comfortable, memorable, and hassle-free.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <ServiceCard
              key={service.title}
              {...service}
              delay={index * 0.1}
            />
          ))}
        </div>
      </div>
      
      <PaymentPartners />
    </div>
  );
}